import { Paper, Typography } from '@material-ui/core';

const TrendTooltip = ({ active, payload, label }: any) => {
    if (!active || !payload?.length) return null;

    return (
        <Paper
            style={{
                padding: 12,
                borderRadius: 10,
            }}
        >
            <Typography
                variant="subtitle2"
                gutterBottom
            >
                {label}
            </Typography>

            {payload.map((item: any) => (
                <Typography
                    key={item.dataKey}
                    style={{
                        color: item.color,
                    }}
                >
                    {item.name}: {item.value.toLocaleString()}
                </Typography>
            ))}
        </Paper>
    );
};

export default TrendTooltip;